// extracted by mini-css-extract-plugin
module.exports = {"container":"DesktopSubNav-module--container--3qLfZ","active":"DesktopSubNav-module--active--ETrrJ"};